import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "../components/kit";
import api, { formatApiErrorDetail } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1600);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="Set a new password for your account." testId="reset-page">
      {done ? (
        <div data-testid="reset-confirm" style={{ padding: "var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--surface-brand-wash)", color: "var(--buktu-green-deep)", font: "var(--type-body-sm)" }}>
          Password updated. Redirecting you to sign in…
        </div>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          {error && <div style={errStyle}>{error}</div>}
          {!token && <div style={errStyle}>Missing reset token. Please use the link from your email.</div>}
          <label style={lbl}>New password
            <input data-testid="reset-password" className="buktu-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" minLength={6} required />
          </label>
          <Button type="submit" full size="lg" data-testid="reset-submit" disabled={loading || !token}>
            {loading ? "Updating…" : "Update password"}
          </Button>
          <Link to="/login" data-testid="reset-back-link" style={{ color: "var(--text-link)", font: "var(--type-body-sm)", textAlign: "center" }}>← Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}

const lbl = { display: "flex", flexDirection: "column", gap: "var(--space-2)", font: "var(--type-label)", color: "var(--text-strong)" };
const errStyle = { padding: "var(--space-3) var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--status-risk-soft)", color: "#8a2a1a", font: "var(--type-body-sm)", fontSize: 13 };
